import React, { Component } from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import TableCell from '@material-ui/core/TableCell';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
//Ícones
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//Componentes
import GenericListPage from './GenericListPage';
//Controller
import AdministradorController from '../controllers/AdministradorController';
//Úteis
import deepCopy from '../utils/deepCopy';

/**
 * Componente para listagem de administradores
 */
class AdministradorListPage extends Component {
    constructor(props) {
        super(props);
        //Bindings
        this.handleChange = this.handleChange.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.handleRenderItem = this.handleRenderItem.bind(this);
        //Controllers
        this.administradorController = new AdministradorController();
        //Estado inicial
        this.state = {
            nome: ''
        };
    }

    /**
     * Trata as alterações nos campos do formulário e atualiza o state
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Cria uma cópia do estado atual
        const state = deepCopy(this.state);
        //Atualiza somente o valor do campo alterado
        state[event.target.name] = event.target.value;
        //Atualiza o estado
        this.setState(state);
    }

    /**
     * Evento disparado para obter os parâmetros do filtros
     * @return {Object} Retorna os parâmetros informados pelo usuário
     */
    handleFilter() {
        //Recupera os parâmetros preenchidos pelo usuário
        const { nome } = this.state;
        //Repassa os parâmetros para o filtro
        return { nome };
    }

    /**
     * Renderiza um item da lista
     * @param {Object} item Item a ser renderizado
     * @returns {React.Component} Retorna a linha da tabela correspondente
     */
    handleRenderItem(item) {
        return (
            <React.Fragment>
                <TableCell>{item.nome}</TableCell>
                <TableCell>{item.email}</TableCell>
            </React.Fragment>
        );
    }
    
    render() {
        const { onLogout, usuario, empresa, permissoes } = this.props;
        const { nome } = this.state;
        
        return (
            <GenericListPage resource="administrador" controller={this.administradorController} columnNames={['Nome', 'E-mail']} onRenderItem={this.handleRenderItem} onLogout={onLogout} onFilter={this.handleFilter} usuario={usuario} empresa={empresa} permissoes={permissoes} >
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                        <Typography>Filtro</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={1}>
                            <Grid item xs={12} >
                                <TextField
                                    name="nome"
                                    label="Nome"
                                    type="text"
                                    placeholder="Nome do administrador"
                                    variant="outlined"
                                    fullWidth
                                    value={nome}
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} container justify="flex-end" >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                >
                                    Filtrar
                                </Button>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </GenericListPage>
            
        );
    }
}

AdministradorListPage.propTypes = {
    /** Callback executado quando o usuário realiza logout do sistema */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired
};

export default AdministradorListPage;